import useAsyncData from "../../../../hooks/use-async-data";
import userService from "../../user.service";
import UserRailyOfficerList from "./user-raily-officer-list";
import UserRailyOfficerListParams from "./user-raily-officer-list-params";

const useRailyOfficerList = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<UserRailyOfficerList>({ data: [], totalCount: 0 });

  const load = async (
    params: UserRailyOfficerListParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const railyOfficerList = await userService.getRailyOfficerList(
        params,
        signal,
      );

      setData(railyOfficerList);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useRailyOfficerList;
